import axios from "axios";

const crBaseURL = process.env.REACT_APP_CR_API_URL;

const crInstance = axios.create({
  baseURL: `${crBaseURL}/`,
  headers: {
    "Content-Type": "application/json",
  },
});

export default crInstance;
